// src/data/exercises/L3_05.js

const accountOptions = [
  '資本金', '売上', '貸倒引当金', '貸倒損失', '売掛金'];

export const L3_05 = {
  title: '簿記　3級（第219-5回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
      content: {

     parts: [
        { type: 'ruby', text: '当期', ruby: 'とうき' },
        { type: 'text', value: 'に' },
        { type: 'ruby', text: '生', ruby: 'しょう' },
        { type: 'text', value: 'じた' },
        { type: 'ruby', text: '鹿児島', ruby: 'かごしま' },
        { type: 'ruby', text: '株式会社', ruby: 'かぶしきがいしゃ' },
        { type: 'text', value: 'に' },
        { type: 'ruby', text: '対', ruby: 'たい' },
        { type: 'text', value: 'する' },
        { type: 'ruby', text: '売掛金', ruby: 'うりかけきん' },
        { type: 'text', value: '￥197,000が' },
        { type: 'ruby', text: '回収不能', ruby: 'かいしゅうふのう' },
        { type: 'text', value: 'となり、' },
        { type: 'ruby', text: '全額', ruby: 'ぜんがく' },
        { type: 'ruby', text: '貸倒れ', ruby: 'かしだおれ' },
        { type: 'ruby', text: '処理', ruby: 'しょり' },
        { type: 'text', value: 'した。' }
    ]
    
    ,
      },
      table: {
        options: accountOptions,
      },
      answer: [
        { debitAccount: '貸倒損失', debitAmount: 197000, creditAccount: '売掛金', creditAmount: 197000 },
      ],

      // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {

        parts: [
          { type: 'text', value: '当期・売掛金￥197,000が回収不能・貸倒れ処理 \n' },
          { type: 'text', value: '①当期・売掛金回収不能・貸倒れ処理なので、貸倒損失が発生します。\n' },
          { type: 'styled', value: '貸倒損失の発生は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '売掛金￥197,000が回収不能 \n' },
          { type: 'text', value: '②売掛金が回収不能なので、売掛金が減少（マイナス）します。\n' },
          { type: 'styled', value: '売掛金の減少（マイナス）は貸方（右・Ｃｒ）に記入します。', color: 'red', bold: true },
        ]

      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`当期・売掛金￥197,000が回収不能・貸倒れ処理
①当期・売掛金回収不能・貸倒れ処理なので、貸倒損失が発生します。

売掛金￥197,000が回収不能
②売掛金が回収不能なので、売掛金が減少（マイナス）します。

`,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {
             parts: [
          { type: 'text', value: '当期・売掛金￥197,000が回収不能・貸倒れ処理 \n' },
          { type: 'text', value: '①当期・売掛金回収不能・貸倒れ処理なので、貸倒損失が発生します。\n' },
          { type: 'styled', value: '貸倒損失の発生は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '売掛金￥197,000が回収不能 \n' },
          { type: 'text', value: '②売掛金が回収不能なので、売掛金が減少（マイナス）します。\n' },
          { type: 'styled', value: '売掛金の減少（マイナス）は貸方（右・Ｃｒ）に記入します。', color: 'red', bold: true },
        ]
          }
        ],
       
        
      },
    },
  ],
};